import { render, staticRenderFns } from "./BdrTableB2B.vue?vue&type=template&id=11d9fa77&scoped=true&"
import script from "./BdrTableB2B.vue?vue&type=script&lang=js&"
export * from "./BdrTableB2B.vue?vue&type=script&lang=js&"
import style0 from "./BdrTableB2B.vue?vue&type=style&index=0&id=11d9fa77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d9fa77",
  null
  
)

export default component.exports